import { useQuery } from "@tanstack/react-query";

import { getFootprintingCropAssessmentsRequiringReview } from "services";

import { getFarmIdFromLocalStorage } from "utils";

import { FOOTPRINTING_CROP_ASSESSMENTS_REQUIRING_REVIEW } from "consts";

import { CropAssessment } from "models";

export const useGetFootprintingCropAssessmentsRequiringReview = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const farmId = getFarmIdFromLocalStorage();

  return useQuery<{
    [year: string]: {
      [cropId: string]: CropAssessment;
    };
  }>({
    queryKey: [FOOTPRINTING_CROP_ASSESSMENTS_REQUIRING_REVIEW, farmId],
    queryFn: () => getFootprintingCropAssessmentsRequiringReview(farmId ?? ""),
    enabled: enabled && !!farmId,
  });
};
